import { render, staticRenderFns } from "./CustomFieldsIterator.vue?vue&type=template&id=b64a40a0&scoped=true"
import script from "./CustomFieldsIterator.vue?vue&type=script&lang=js"
export * from "./CustomFieldsIterator.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldsIterator.vue?vue&type=style&index=0&id=b64a40a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64a40a0",
  null
  
)

export default component.exports